import { render, staticRenderFns } from "./BookRoutesPopup.vue?vue&type=template&id=86f5cd1a&"
import script from "./BookRoutesPopup.vue?vue&type=script&lang=js&"
export * from "./BookRoutesPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports